import React, { useCallback, useEffect, useState } from "react";

import { getAllAdminMethods } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const MethodList = () => {
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllMethods = useCallback(() => {
    getAllAdminMethods({
      signal,
    })
      .then((res) => {
        setMethods(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllMethods();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${methods.length} methods`}
        description="View, add or update regenerative methods here."
        extra={
          <Button size="small" type="secondary" href="/method/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={methods}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/method/update/",
                  tooltip: "Edit this method",
                },
              ],
              exclude: [
                "utc",
                "tasks",
                "summaryColor",
                "summary",
                "sq",
                "so",
                "sa",
                "questions",
                "quantityStep",
                "quantityQuestionPlaceholder",
                "quantityQuestion",
                "quantityMin",
                "quantityMax",
                "proceeds",
                "partialApplications",
                "livestock",
                "link",
                "lastYear",
                "image",
                "disadvantages",
                "description",
                "date",
                "crops",
                "cropFactors",
                "continuation",
                "co2Storage",
                "biodiversity",
                "areaQuestion",
                "advantages",
                "additions",
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
